import { getElementFromEvent } from '../utils';
import ReadingTime from './ReadingTime';
import { disablePageScroll, enablePageScroll } from 'scroll-lock';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

export default class StoryMenu {
	constructor(el, container) {
		// DOM elements
		this.el = el;
		this.container = container;
		this.menuItems = this.el.querySelectorAll('[data-chapter-link]');
		this.chaptersContainer = this.container.querySelector('[data-chapters]');
		this.chapters = this.container.querySelectorAll('[data-chapter]');
		this.authorsToggle = this.container.querySelector('[data-story-authors-toggle]');
		this.authorsToggleBackground = this.container.querySelector('[data-story-authors-bg]');
		this.menuToggle = this.container.querySelector('[data-story-menu-toggle]');
		this.menuBackground = this.container.querySelector('[data-story-menu-bg]');

		// Reading time component
		this.readingTime = new ReadingTime(this.container.querySelector('[data-reading-time]'), this.container);

		const mm = gsap.matchMedia();

		mm.add('(max-width: 767px)', () => {
			this.scrollTrigger = new ScrollTrigger({
				trigger: this.container.querySelector('.c-single-story'),
				end: 'bottom bottom-=18px',
				onToggle: () => {
					this.authorsToggle.classList.toggle('is-fixed');
					this.menuToggle.classList.toggle('is-fixed');
				},
			});
		});

		mm.add('(min-width: 768px)', () => {
			this.menuToggle.classList.remove('is-fixed');
			this.authorsToggle.classList.remove('is-fixed');
			enablePageScroll();
		});

		// Events
		this.el.addEventListener('click', (e) => {
			const link = getElementFromEvent(e, '[data-chapter-link]');

			if (link) {
				e.preventDefault();

				gsap.to(window, {
					duration: 1,
					ease: 'power2.inOut',
					scrollTo: {
						y: link.hash,
						offsetY: 100,
					},
				});
			}
		});

		this.authorsToggle.addEventListener('click', (e) => {
			this.container.classList.add('single-story--authors-active');
			disablePageScroll();
		});

		this.authorsToggleBackground.addEventListener('click', (e) => {
			this.container.classList.remove('single-story--authors-active');
			enablePageScroll();
		});

		this.menuToggle.addEventListener('click', (e) => {
			this.container.classList.add('single-story--menu-active');
			disablePageScroll();
		});

		this.menuBackground.addEventListener('click', (e) => {
			this.container.classList.remove('single-story--menu-active');
			enablePageScroll();
		});

		this.boundHandleScroll = this.handleScroll.bind(this);
		window.addEventListener('scroll', this.boundHandleScroll);
	}

	handleScroll(e) {
		const check = window.scrollY + 200;

		this.chapters.forEach((group, index) => {
			const rect = group.getBoundingClientRect();
			let active = false;

			if (
				check >= rect.top + document.documentElement.scrollTop &&
				check <= rect.bottom + document.documentElement.scrollTop
			) {
				active = true;
				this.menuItems[index].classList.add('is-active');
			} else {
				active = false;
				this.menuItems[index].classList.remove('is-active');
			}
		});
	}

	destroy() {
		window.removeEventListener('scroll', this.boundHandleScroll);
		this.readingTime.destroy();

		if (!this.scrollTrigger) {
			return;
		}

		this.scrollTrigger.kill();
		this.scrollTrigger = null;
	}
}
